import {dark} from './dark';
import {padding} from '../core/padding.style';
import {fontSize} from '../core/fontSize.style';
import {colors} from '../core/tradeShow.color.style';

const templateTheme = {
  preferences: {
    template: 'tradeShow',
    homePage: {
      header: false,
      aboutUs: {
        show: true,
        content: {
          header: true,
          logo: false,
          contact: false,
          orderButton: false
        }
      },
      ourFood: true,
      getInTouch: true,
      restaurantPanel: true
    }
  },

  container: {
    wider: {
      width: '128rem',
      margin: '1.6rem auto'
    },
    wide: {
      width: 'auto',
      margin: '1.2rem'
    },
    desktop: {
      width: 'auto'
    },
    tablet: {
      width: 'auto'
    },
    phone: {
      width: 'auto',
      margin: 0
    }
  },

  homePage: {
    title: {
      fontSize: fontSize.size22,
      fontWeight: 900
    },
    width: '100%',
    color: colors.C1,
    background: colors.BC1,
    offsetTop: '4.6rem',
    padding: 0,
    mobile: {
      margin: '4.6rem 0'
    },
    container: {
      margin: '12rem 2.4rem auto 37.4rem'
    },
    linkColor: colors.C3,
    border: `0.1rem solid ${colors.BD1}`,
    contact: {
      padding: padding.padding06
    },
    parsedContent: {
      fontSize: fontSize.size16,
      background: colors.BC2,
      padding: padding.padding24,
      h: {
        display: 'block',
        minWidth: '24rem',
        width: '60%',
        height: '0.1rem',
        border: `0.1rem solid ${colors.BD2}`,
        margin: '1rem auto 0'
      }
    },
    header: {
      fontSize: fontSize.size24,
      padding: padding.padding12
    },
    panelContent: {
      background: colors.BC2,
      button: {
        fontSize: fontSize.size14,
        color: colors.C2,
        margin: '1rem auto',
        padding: '0.8rem 2rem 0.6rem',
        width: '34rem',
        backgroundColor1: colors.C3,
        backgroundColor2: colors.C4,
        hoverColor1: colors.C3a,
        hoverColor2: colors.C4a,
        radius: '0.6rem'
      }
    },
    actionPanel: {
      background: colors.BC3
    },
    facebookLike: {
      background: colors.BC1,
      color: colors.C1,
      padding: '2.4rem 0',
      mobile: {
        margin: '0 auto 2.4rem'
      }
    }
  },

  checkoutPage: {
    margin: 0,
    borderRight: 0,
    textColor: colors.C1,
    payment: {
      title: {
        fontSize: '1.8rem'
      }
    },
    color: '#000',
    bigLabelColor: '#e8773b',
    deliveryAddressLabelColor: '#211c1d',
    inputErrorBackgroundColor: '#F2DEDE',
    inputTextColor: '#979797',
    inputTextBackground: '#f7f7f2',
    inputTextBorderColor: '#e7e7e7',
    inputTextShadowColor: '#b4b4b4',
    smallTextColor: '#a6a6a6',
    requiredMessageColor: '#b94a48',
    paymentsDisclamerBackground: '#fbfbfb',
    formErrorBackground: '#b77a7a',
    formErrorColor: colors.C2,
    deliveryFeeBackgroundColor: colors.BC6,
    linkColor: colors.C5,
    selectedDayBackground: colors.BC7,
    selectedDayColor: colors.C2,
    modalButtonMargin: padding.padding06,
    fontWeight: 'bold'
  },

  contactPage: {
    width: '53rem',
    backgroundColor: colors.BC5,
    offsetTop: '4.6rem',
    fontSize: fontSize.size14,
    linkColor: colors.C3,

    facebookLike: {
      background: colors.BC5,
      color: colors.C2,
      maxWidth: '53rem',
      padding: '0 0 2.4rem 0',
      mobile: {
        margin: '0 auto 2.4rem'
      }
    }
  },

  spinner: {
    c1: '#e7773b',
    c2: '#ed996c',
    c3: '#f3bb9d',
    c4: '#f9ddce'
  }
};

export const tradeShow = Object.assign({}, dark, templateTheme);



// WEBPACK FOOTER //
// ./styles/themes/tradeShow.js